import {Link} from "react-router-dom";

export const CustomToastWithLink = (text, url) => {
    return (<div>
        <Link to={url} target={"_blank"}>{text}</Link>
    </div>)
}

